import {Check, ThumbsDown} from "lucide-react";
import React from "react";
import {Button} from "antd";
import {IPoll} from "../../types/poll.types";

interface INoResult {
    totalVotes: number;
    selectedPoll: IPoll | null;
    handleDeclareResult: (id: any) => void;
}

const RenderNoResult = (props: INoResult) => {
    return (
        <div className={'no-participation'}>
            <div>
                <ThumbsDown className={'thumb-down-icon'}/>
            </div>
            <div>
                <h4>Nobody participated in this poll!</h4>
            </div>
            <div>
                Total Votes: {props.totalVotes}
            </div>
            {
                !props.selectedPoll?.active && props.selectedPoll?.anonymous && !props.selectedPoll?.resultDeclared &&
                <Button type={"primary"} className={'declare-result-btn'}
                        onClick={() => props.handleDeclareResult(props.selectedPoll?.id)}>
                    <Check className={'poll-action-icon'}/> Declare Result
                </Button>
            }
        </div>
    )
}

export default RenderNoResult;